import React from "react";
import AudioDisplay from "components/AttachmentPreview/Display/AudioDisplay";
import { ReactComponent as CloseIcon } from "assets/img/icons/cancel.svg";
import ReactDOM from "react-dom";

const styles = {
  previewDialog: {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "fixed",
    top: "0",
    left: "0",
    zIndex: "1100",
    color: "black",
  },
  previewDialogBackdrop: {
    height: "inherit",
    width: "inherit",
    position: "fixed",
    backgroundColor: "black",
    top: "0",
    left: "0",
    zIndex: "-1",
    pointerEvents: "none",
    opacity: "0.7",
  },
  closeIcon: {
    width: "25px",
    cursor: "pointer",
    fill: "white",
  },

  closeContainer: {
    padding: "20px",
    position: "absolute",
    top: 0,
    right: 0,
  },
};

function AudioModal({
  closePreviewDailog,
  preventDefaultOnClick,
  attachment,
  type,
}) {
  const classes = styles;

  const DisplayAudioModal = () => {
    return (
      <div style={classes.previewDialog} onClick={closePreviewDailog}>
        <div style={classes.previewDialogBackdrop}></div>
        <div style={classes.closeContainer}>
          <CloseIcon style={classes.closeIcon} onClick={closePreviewDailog} />
        </div>
        <div
          className="imagePreviewContentContainer audioPreviewContentContainer"
          onClick={preventDefaultOnClick}
        >
          <AudioDisplay attachmentSrc={attachment} type="audio/mpeg" />
        </div>
      </div>
    );
  };

  return (
    <React.Fragment>
      {ReactDOM.createPortal(
        <DisplayAudioModal />,
        document.getElementById("modal-root")
      )}
    </React.Fragment>
  );
}

export default AudioModal;
